module.exports = __webpack_public_path__ + "static/media/vis2.46075a1a.jpeg";